<template>	

		<div class="knd-colofon" :style="'background-color:#' + kleur">
			<h1>Colofon</h1>
			<div class="knd-colofon-tekst"  v-html='getContent(content, "colofon")'></div>
		</div>

</template>

<script>
	import './colofon.scss';

	export default {
		name: 'Colofon',
		props: ["kleur"],
		computed: {
		},
		data: function() {
			return {
				content: this.$store.state.content
			}
		},
		mounted() {
			
		},
		methods: {
			getContent(content, label) {
				// if (this.$store.state.language === "nl") {
					return content[label].data;
				// }
				// else {
					// return content[label].data5891;	
				// }
			},
		}
	}
</script>